export default __webpack_public_path__ + "media/images/hometown-425c748921e8a752a8ab8def82e0cbe7.svg";